import {Component, computed, signal} from '@angular/core'
import {MatSlider, MatSliderThumb} from '@angular/material/slider'
import {FormsModule} from '@angular/forms'
import {DecimalPipe, JsonPipe} from '@angular/common'
import {MatChipListbox, MatChipOption} from '@angular/material/chips'

export const color = (value: number) => {
  let red = 255
  let green = 255
  let blue = 255

  // Greater than 0, make it greener by decreasing the amount of red.
  if (value > 0) {
    red = 255 - Math.round(value * 240)
    green = 230 // Not so very green
    blue = 23
  }
  if (value < 0) {
    green = 255 - Math.round(value * -1 * 240)
    blue = 46
  }

  return `rgb(${red},${green},${blue})`
}

@Component({
  selector: 'spb-test',
  imports: [
    MatSlider,
    MatSliderThumb,
    FormsModule,
    DecimalPipe,
    MatChipListbox,
    MatChipOption,
    JsonPipe
  ],
  templateUrl: './test.html',
  styleUrl: './test.scss'
})
export class Test {
  public value = signal(0)

  public items = signal<number[]>([])

  public keys = ['a', 'b', 'c']

  public color = computed(() => {
    return color(this.value())
  })
}
